import React, { useState } from 'react';
import { FaTrash } from 'react-icons/fa';
import formatValue from '~/utils/formatValue';
import { useAuth } from '~/context/AuthContext';
import posIcon from '~/assets/img/pos-icon.svg';
import { Spinner } from 'reactstrap';
import { BsCheckLg } from 'react-icons/bs';
import { BANESTES_METHOD, CLUBE_METHOD } from '~/utils/consts';
import toast from 'react-hot-toast';
import { BalconyResetFlowModal } from '~/components/BalconyPageComponents/BalconyPaymentAreaPinpad/styles';
import { Button } from 'takeat-design-system-ui-kit';
import api2 from '~/services/api2';
import { ReactComponent as AlertIcon } from '../../../../../assets/img/delete2.svg';
import {
  ActionsDiv,
  DeletePaymentForm,
  FirstRow,
  MaquininhaPaymentAlertContainer,
  Row,
  SecondRow,
} from './styles';

function getChannelIdentifier(str) {
  if (!str) {
    return null;
  }

  const parts = str.split('-');
  if (parts.length < 2) return str;
  return parts.slice(0, 2).join('-');
}

export const PaymentRow = ({
  payment,
  method,
  stoneTransactions,
  allPaymentMethods,
  handleStoneTransactions,
  loadingPos,
  toggleCancelPos,
  onDeletingPayment,
  onCancelingDeletingPayment,
  getPayments,
  balconySession,
}) => {
  const { user } = useAuth();
  const excludeIds = [CLUBE_METHOD, BANESTES_METHOD];
  const channel = getChannelIdentifier(payment?.channel);
  const isPinpadChannel = channel === 'pinpad';
  const [loading, setLoading] = useState(false);
  const [isDeletingPayment, setIsDeletingPayment] = useState(false);

  function updateDeletingPayment(state) {
    setIsDeletingPayment(state);
  }

  const deletePayments = async (id) => {
    try {
      await api2.delete(`restaurants/payments/${id}`);
      toast.success('Pagamento removido com sucesso!');
      getPayments(balconySession?.session?.id);
      updateDeletingPayment(false);
    } catch (error) {
      toast.error('Erro ao deletar pagamento');
    }
  };

  return (
    <>
      <BalconyResetFlowModal
        open={isDeletingPayment}
        toggle={() => updateDeletingPayment(false)}
        style={{
          width: 'fit-content',
          height: 'fit-content',
        }}
      >
        <section>
          <AlertIcon />
        </section>
        <div>
          <header>
            <div>
              <p>Tem certeza que deseja excluir este pagamento já realizado?</p>
              <div
                style={{
                  marginBottom: '16px',
                }}
              />
            </div>
          </header>
          <footer>
            <Button
              onClick={() => updateDeletingPayment(false)}
              variant="outlined"
              style={{
                width: '40%',
                fontFamily: 'Poppins',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 600,
                lineHeight: '20px',
                letterSpacing: '0.1px',
              }}
            >
              Não
            </Button>
            <Button
              disabled={loading}
              style={{
                width: '60%',
                fontFamily: 'Poppins',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 600,
                lineHeight: '20px',
                letterSpacing: '0.1px',
              }}
              onClick={() => {
                setLoading(true);
                try {
                  deletePayments(payment.id);
                } finally {
                  setLoading(false);
                }
              }}
            >
              Confirmar cancelamento
            </Button>
          </footer>
        </div>
      </BalconyResetFlowModal>
      <Row>
        <FirstRow
          style={{ color: excludeIds.includes(payment?.id) && '#2ec9b7' }}
        >
          <span>{payment?.payment_method?.name}</span>
          {isPinpadChannel && (
            <MaquininhaPaymentAlertContainer>
              Maquininha
            </MaquininhaPaymentAlertContainer>
          )}
        </FirstRow>
        <SecondRow>
          <span>{formatValue(payment.payment_value)}</span>
        </SecondRow>
        <td style={{ textAlign: 'right' }}>
          <ActionsDiv>
            {user.has_stone_pdv &&
              ['CREDIT', 'DEBIT', 'credit', 'debit'].includes(
                allPaymentMethods.find(
                  (pay) => pay.id === payment.payment_method_id
                )?.method || false
              ) &&
              parseFloat(payment.payment_value) > 0 && (
                <td style={{ textAlign: 'center' }}>
                  {!stoneTransactions.find(
                    (trans) =>
                      trans.payment_balcony_id === payment.id &&
                      trans.status !== 'canceled'
                  ) && (
                    <div>
                      <DeletePaymentForm
                        to="#"
                        onClick={() =>
                          !loadingPos &&
                          handleStoneTransactions({
                            payment_value: payment.payment_value,
                            payment_balcony_id: payment.id,
                            method: allPaymentMethods.find(
                              (pay) => pay.id === payment.payment_method_id
                            )?.method,
                          })
                        }
                        style={loadingPos ? { pointerEvents: 'none' } : {}}
                      >
                        <img src={posIcon} alt="" />
                      </DeletePaymentForm>
                    </div>
                  )}

                  {stoneTransactions.find(
                    (trans) =>
                      trans.payment_balcony_id === payment.id &&
                      trans.status === 'pending'
                  ) && (
                    <div>
                      <DeletePaymentForm
                        to="#"
                        // onClick={() => toggleCancelPos(payment.id)}
                        disabled={loadingPos}
                      >
                        <Spinner
                          size="sm"
                          color="#3BD2C1"
                          style={{
                            width: 15,
                            height: 15,
                            marginBottom: 4,
                            color: '#3BD2C1',
                            cursor: 'default',
                          }}
                        />
                      </DeletePaymentForm>
                    </div>
                  )}

                  {stoneTransactions.find(
                    (trans) =>
                      trans.payment_balcony_id === payment.id &&
                      trans.paid_at !== null
                  ) && (
                    <div>
                      <DeletePaymentForm
                        to="#"
                        // onClick={() => handleStoneTransactions(payment.id)}
                        disabled={loadingPos}
                      >
                        <BsCheckLg
                          style={{
                            width: 20,
                            height: 20,
                            color: '#3BD2C1',
                          }}
                        />
                      </DeletePaymentForm>
                    </div>
                  )}
                </td>
              )}
            {!excludeIds.includes(method?.id) &&
              !stoneTransactions.find(
                (trans) =>
                  trans.payment_balcony_id === payment.id &&
                  trans.paid_at !== null
              ) && (
                <FaTrash
                  color={isPinpadChannel && '#C6C6C6'}
                  size={15}
                  onClick={() => {
                    if (isPinpadChannel) {
                      toast.error(
                        'Pagamentos com a maquininha não podem ser excluídos'
                      );
                      return;
                    }

                    updateDeletingPayment(true);
                  }}
                />
              )}
          </ActionsDiv>
        </td>
      </Row>
    </>
  );
};
